<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6" >
          <v-file-input
            v-model="item.file"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            required
            show-size
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.idlynxter"
            :error-messages="idlynxterErrors"
            :label="$t('profile.idlynxter')"
            required
            @input="$v.item.idlynxter.$touch()"
            @blur="$v.item.idlynxter.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.value"
            :error-messages="valueErrors"
            :label="$t('profile.value')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.value.$touch()"
            @blur="$v.item.value.$touch()"
          />
        </v-col>
      </v-row>
   

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';

export default {
  name: 'UpdateValueLynxterForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        file: null,
        idlynxter : null,
        value: null,
    };
  },
  computed: {
    isLoading() {
      return (
        this.isLoading
       );
    },
    ...mapFields('profilefile', {
      isLoading : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    valueErrors() {
      const errors = [];
      if (!this.$v.item.value.$dirty) return errors;
      has(this.violations, 'value') && errors.push(this.violations.value);
      !this.$v.item.value.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    idlynxterErrors() {
      const errors = [];
      if (!this.$v.item.idlynxter.$dirty) return errors;
      has(this.violations, 'idlynxter') && errors.push(this.violations.idlynxter);
      !this.$v.item.idlynxter.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.item.file.$dirty) return errors;
      has(this.violations, 'file') && errors.push(this.violations.file);
      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      file: {
        maxsizefile : maxsizefile(20),
      },
      idlynxter: {
        required,
      },
      value: {
        required,
      },

    }
  }
};
</script>
